Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line camelcase
const Dashboard_1 = require("../Sections/Dashboard/Dashboard");

// eslint-disable-next-line
const DashboardView = function () { return Dashboard_1.default(); };
exports.default = DashboardView;
// # sourceMappingURL=DashboardView.js.map
